import cn from 'classnames';
import {FC} from 'react';
import {RegistrationGender} from '../../../model';
import styles from './GenderToggle.module.css';

const genderOptions: {value: RegistrationGender; label: string}[] = [
	{value: 'male', label: 'Мужской'},
	{value: 'female', label: 'Женский'},
];

type Props = {
	value: RegistrationGender | null;
	onChange?: (value: RegistrationGender) => void;
	disabled?: boolean;
	className?: string;
	/** id видимой подписи «Пол». */
	labelledBy?: string;
};

export const GenderToggle: FC<Props> = ({value, onChange, disabled = false, className, labelledBy}) => {
	return (
		<div
			className={cn(styles.root, disabled && styles.rootDisabled, className)}
			role="radiogroup"
			aria-labelledby={labelledBy}
			aria-readonly={disabled || undefined}
		>
			{genderOptions.map((option) => (
				<button
					key={option.value}
					type="button"
					role="radio"
					aria-checked={value === option.value}
					tabIndex={disabled ? -1 : undefined}
					className={cn(styles.option, value === option.value && styles.optionActive)}
					onClick={() => onChange?.(option.value)}
				>
					{option.label}
				</button>
			))}
		</div>
	);
};
